import type { FC } from 'react';
import { useReducer } from 'react';
import type { IContainerChildrenProps } from 'utils';
import { UIContext } from './UIContext';
import { UIReducer } from './UIReducer';

const UIProvider: FC<IContainerChildrenProps> = ({ children }) => {
  const [state, dispatch] = useReducer(UIReducer, {
    modelIsUpdated: false,
    apiIsUpdated: false,
    modelIsModified: false,
    flowIsUpdated: false,
    panelTop: 0
  });

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <UIContext.Provider value={{ state, dispatch }}>{children}</UIContext.Provider>;
};

export default UIProvider;
